import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useSyncExternalStore } from "react";
import NumberFlow from "@number-flow/react";
let _supports = null;
function getSupportsSnapshot() {
    if (_supports === null) {
        _supports = typeof CSS !== "undefined" && !!CSS.supports?.("line-height", "mod(1,1)");
    }
    return _supports;
}
const emptySubscribe = () => () => true;
const getServerSnapshot = () => true;
const NumFlowWithFallback = (props) => {
    const { value, format, prefix = "", suffix = "", className, ...rest } = props;
    const supportsNumberFlow = useSyncExternalStore(emptySubscribe, getSupportsSnapshot, getServerSnapshot);
    const formatted = useMemo(() => {
        const numValue = typeof value === "string" ? parseFloat(value) : value;
        const formatter = new Intl.NumberFormat(undefined, format);
        return `${prefix}${formatter.format(numValue)}${suffix}`;
    }, [value, format, prefix, suffix]);
    if (!supportsNumberFlow) {
        return _jsx("span", { className: className, children: formatted });
    }
    return _jsx(NumberFlow, { value: value, format: format, prefix: prefix, suffix: suffix, className: className, ...rest });
};
export default NumFlowWithFallback;
